<template>
  <div class="typed-on-paper-a4">
    <div>
      <h1 class="text-align-center">CAMPAIGNS</h1>
      <br>
      <p class="text-align-left">
        This is the list of "Flying Tin Cans" Campaigns and their current status.</p>
      <p class="text-align-left">
        We fly one mission every Sunday at around 1900 UTC / ZULU, which lasts around two to three hours.
        More information about how to join us can be found on our forums or Discord.
      </p>
      <p class="text-align-left">
        Click on any campaign to access information about the unit setup of the campaign, mission briefings and after action
        reports.
      </p>

    </div>
    <template>
      <h1>Ongoing Campaigns</h1>
      <DivLinkButton
        v-for="campaign in campaigns"
        v-if="campaign.campaign_status <= 1"
        v-bind:key="campaign.id"
        v-bind="{routeName: 'Missions', routeParams: {campaign_id: campaign.id}}">
        <CampaignInfoBaseComp v-bind="campaign"></CampaignInfoBaseComp>
      </DivLinkButton>
    </template>
    <template>
      <h1>Finished Campaigns</h1>
      <DivLinkButton
        v-for="campaign in campaigns"
        v-if="campaign.campaign_status > 1"
        v-bind:key="campaign.id"
        v-bind="{routeName: 'Missions', routeParams: {campaign_id: campaign.id}}">
        <CampaignInfoBaseComp v-bind="campaign"></CampaignInfoBaseComp>
      </DivLinkButton>
    </template>
  </div>
</template>

<script>
import CampaignInfoBaseComp from "./CampaignInfoBaseComp";
import DivLinkButton from "../basic_comp/DivLinkButton";

export default {
  name: 'CampaignList',
  components: {
    CampaignInfoBaseComp,
    DivLinkButton
  },
  mounted () {

    this.$dbCon.requestViewData(this.$options.name,
      {view: "campaign_list"})
      .then(response => {
        this.campaigns = response;
        // return this.$dbCon.requestViewData(this.$options.name,
        //   {view: "campaign_list", campaign_status: 1})
      })
      // .then(response => {
      //   this.ongoing_campaigns = response;
      // })
      .catch(error => {
        console.log(error.message);
      });
  },
  data () {
    return {
      // ongoing_campaigns: null,
      campaigns: null,
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignList.vue